import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import EquipmentListView from 'src/views/equipment/Equipments';
import EquipmentDetailView from './EquipmentDetail';

const EquiptmentView = () => (
  <Routes>
    <Route index element={<EquipmentListView />} />
    <Route path="equipments" element={<Navigate to="" replace />} />
    <Route path=":id/*" element={<EquipmentDetailView />} />
    <Route path=":id" element={<EquipmentDetailView />} />
  </Routes>
);

export default EquiptmentView;
